export const initCtaTool = () => {
    const cta_btn = document.querySelector('.cta-primary__content > a.btn')
    const paypal_frm = document.querySelector('.paypal-form > form')

    if (!cta_btn) {
        return
    }

    cta_btn.addEventListener('click', (e) => {
        e.preventDefault()
        paypal_frm.submit()
    })
}
